<template>
  <div class="password-input">
    <b-form-input
        :value="value"
        @input="updateValue($event)"
        :placeholder="placeholder"
        required
        :type="showPass ? 'text' : 'password'"
        size="sm"
        trim
        maxlength="15"
    ></b-form-input>
    <b-button class="show-pass-btn" @click="togglePasswordType">
      <span v-if="showPass">
        <b-icon-eye></b-icon-eye>
      </span>
      <span v-else>
        <b-icon-eye-slash></b-icon-eye-slash>
      </span>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "PasswordInput",
  props: ['value','placeholder'],
  data () {
    return {
      pageRowStyle: {},
      showPass: false
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    togglePasswordType() {
      this.showPass = !this.showPass;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/style/_custom.scss";

.form-control {
  border: 1px solid #ffffff;
  border-radius: 0 !important;
}
input, input:focus{
  color: $primary-color;
}
.password-input {
  position: relative;
  .show-pass-btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    background-color: #73BC44;
    border: none;
    border-radius: 0;
    padding: 0 10px;
    &:focus, &:active, &:hover {
      background: #73BC44;
      box-shadow: none !important;
    }
  }
}
</style>
